module.exports = __webpack_public_path__ + "ca649df4611a5c636648802aa80283e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/video-thumbnail-4-fund-families.png
// module id = 1940
// module chunks = 0